import * as React from "react";
import { OI } from "../onam/mark";
import { FEATURES } from "../onam/features";

type Props = React.SVGProps<SVGSVGElement> & { title?: string };

function BaseInfoCircleIcon({ title, ...props }: Props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      role="img"
      {...props}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25Z"
        stroke="currentColor"
        strokeWidth={1.5}
      />
      <path
        d="M12 11.8135V16.8135"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <path
        d="M12 9.68848C12.6904 9.68848 13.25 9.12883 13.25 8.43848C13.25 7.74812 12.6904 7.18848 12 7.18848C11.3096 7.18848 10.75 7.74812 10.75 8.43848C10.75 9.12883 11.3096 9.68848 12 9.68848Z"
        fill="currentColor"
      />
    </svg>
  );
}

/* With the ONAM skin (FEATURES.curationSkin) this draws ONAM's "info" glyph instead (onam/mark.tsx). */
const InfoCircleIconSkin = (props: any) =>
  FEATURES.curationSkin ? (
    <OI n="info" size={props.size || 20} className={props.className} style={props.style} onClick={props.onClick} title={props.title} color={props.color}
      onMouseOver={props.onMouseOver} onMouseOut={props.onMouseOut} onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave} />
  ) : (
    <BaseInfoCircleIcon {...props} />
  );
export default InfoCircleIconSkin;
